import i18n from '@ms/lang/i18n.js'

const CURRENCY_UNIT = i18n.t('CURRENCY_UNIT')

export default {
  imgBanner: require('./images/banner.png'),
  imgBettings: require('./images/bettings.png'),
  imgLose: require('./images/lose.png'),

  exampleList: [
    '1. Michael and John placed their first bet on MSport;',

    '2. After their bet settled, Michael won his first bet while John lost;',

    '3. MSport will credit John a Free Bet for his lost.'
  ],
  termsConditions: [
    '1. During promotion period, MSport newly registered customers who use their balance (actual paid amount >0) to place a first bet on sports betting on any events and markets will participate in this promotion automatically. <span class="colorP">(Virtual, Jackpot and Games are not included). Customers who have placed their first bet on sports betting before this promotion are not qualified.</span>',

    `2. MSport will credit customers A FREE BET (<span class="colorP">${CURRENCY_UNIT}1.00 Voucher</span>) if their first bet lost. First bet with a Won, Void outcome or be cashed out before settles will not be considered and the following second bet will not be applied to this promotion.`,

    `3. Free Bet credited to customers is a Voucher value ${CURRENCY_UNIT}1.00. Vouchers cannot be withdrawn directly but can be used as cash that count toward the total stake when placing bets.`,

    '4. Vouchers provided in this promotion can be used for betting on soccer, including both pre-match and live betting. (HNB, DNB, ANB markets are not allowed.)',

    '5. Vouchers will be credited in 48 hours to customers\' accounts after each qualified bet settles and will be valid for 7 days. You can check the Validity Status and Period of your Vouchers anytime by going to "Vouchers", under "Me".',

    '6. Promotions and Vouchers are created in order to reward our most valued customers. Under suspect of fraud or abuse of this promotion by any customer, we reserve the right to remove Vouchers and associated winnings from a given account or any associated accounts. MSport reserves the rights to amend, cancel, reclaim or refuse any promotion at our discretion.'
  ],

  shareInfo: {
    shareTopTips: 'Share MSport First Bet',
    shareText: 'WIN or GET A FREE BET for new customers on MSport! Join and enjoy your first risk-free bet NOW! 100% chance to win!',
    shareImgs: [`${process.env.VUE_APP_CDN}images/share/first_bet_refunds2.png`] // 第一个元素为不隐藏金额，第二个元素为隐藏金额
  }
}
